import React, { useEffect } from "react";
import { t } from "../../../utils/i18n";

const Body = ({ transfers, removeTransfer, storeId }) => {
  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip();
  });

  const getAmount = transfer => {
    if (transfer.is_convert) {
      return (
        <>
          {transfer.net_amount} {transfer.source_currency}{" "}
          <i className="fa fa-arrow-right" /> {transfer.net_amount}{" "}
          {transfer.destination_currency == "USDT"
            ? "USD"
            : transfer.destination_currency}
        </>
      );
    } else if (transfer.is_store_receiving_fees) {
      return (
        <>
          {transfer.gross_amount}{" "}
          {transfer.destination_currency == "USDT"
            ? "USD"
            : transfer.destination_currency}
        </>
      );
    }

    return `${transfer.net_amount} ${
      transfer.destination_currency === "USDT"
        ? "USD"
        : transfer.destination_currency
    }`;
  };

  const getDescription = transfer => {
    const {
      source_currency,
      destination_currency,
      source_wallet_id,
      destination_wallet_id,
      default_crypto_wallet_id,
      is_destination_user_wallet,
      is_destination_store_wallet,
      destination_wallet_user_name,
      destination_wallet_user_email,
      destination_wallet_store_name,
      destination_wallet_store_email,
      destination_wallet_store_address,
      blockchain_tx,
      blockchain_address,
      user_email,
      user_name,
      is_external_transfer,
      external_user_name,
      external_user_email
    } = transfer;

    if (source_currency !== destination_currency) return <></>;

    if(is_external_transfer) {
      return (
        <>
          {t("stores.activity.external_payment_from")}
          <br /> {external_user_name}
          <br /> {external_user_email}
        </>
      );
    }

    if (is_destination_store_wallet) {
      return (
        <>
          {destination_wallet_store_name}
          <br /> {destination_wallet_store_address}
          <br /> {destination_wallet_store_email}
        </>
      );
    } else if (
      !source_wallet_id ||
      destination_wallet_id === default_crypto_wallet_id
    ) {
      return source_wallet_id ? (
        <>
          {user_name} <br />
          {user_email}
        </>
      ) : (
        <>
          {t("stores.activity.external_wallet")}
          <br />({source_currency}){blockchain_tx}
        </>
      );
    } else if (is_destination_user_wallet) {
      return (
        <>
          {destination_wallet_user_name}
          <br /> {destination_wallet_user_email}
        </>
      );
    } else {
      return (
        <>
          {t("stores.activity.external_wallet")}
          <br /> ({source_currency} {blockchain_address})
        </>
      );
    }
  };

  const getDescriptionMeta = transfer => {
    if (transfer.completed_at) {
      return (
        <div className="font-0_85">{t("stores.activity.completed", { date: transfer.completed_at })}</div>
      );
    }

    return <div className="font-0_85">{t("stores.activity.created", { date: transfer.created_at })}</div>;
  };

  const getExpiredMeta = transfer => {
    if (transfer.expires_at && transfer.is_expired) {
      return <div className="font-0_85">{t("stores.activity.expired_at", { date: transfer.expires_at })}</div>;
    }

    return <></>;
  };

  const getIncompleteTransferStatus = transfer => {
    const {
      is_complete,
      is_confirmed,
      is_unconfirmed,
      is_failed,
      is_expired
    } = transfer;

    if (
      !is_complete &&
      (!is_confirmed || is_unconfirmed) &&
      !is_failed &&
      !is_expired
    ) {
      return (
        <a
          href="#"
          data-toggle="tooltip"
          title={t("stores.activity.pending_tip")}
        >
          <span>
            <i className="fa fa-info-circle"></i>
          </span>
        </a>
      );
    }

    return <></>;
  };

  const getStatus = transfer => {
    if (transfer.is_expired) {
      return (
        <a href={`/crypto_transfers/${transfer.id}`} className="unlink">
          {t("stores.activity.expired")}
        </a>
      );
    } else {
      return (
        <>
          {transfer.external_status} {getIncompleteTransferStatus(transfer)}
        </>
      );
    }

    return <></>;
  };

  const getResendConfirmationLink = transfer => {
    const {
      is_complete,
      is_confirmed,
      is_unconfirmed,
      is_failed,
      is_expired,
      id
    } = transfer;

    if (
      !is_complete &&
      (!is_confirmed || is_unconfirmed) &&
      !is_failed &&
      !is_expired
    ) {
      return (
        <a
          className={`btn btn-link ${transfer.active_class_by_status}`}
          title={t("stores.activity.resend_title")}
          data-confirm={t("stores.activity.resend_confirm")}
          data-remote="true"
          href={`/crypto_transfers/${id}/resend_confirmation`}
        >
          <i className="fa fa-envelope "></i>
        </a>
      );
    }

    return <></>;
  };

  const getRemoveTransactionLink = transfer => {
    const { is_kept, is_complete, is_pending, id } = transfer;

    if (is_kept && !is_complete && !is_pending) {
      return (
        <a
          className="unlink"
          title={t("stores.activity.remove_title")}
          rel="nofollow"
          onClick={e => removeTransfer(e, transfer.id)}
        >
          <i className="fa fa-trash "></i>
        </a>
      );
    }

    return <></>;
  };

  return (
    <tbody>
      {transfers.map((transfer, i) => (
        <tr key={transfer.id}>
          <td className="actions expand">
            <a
              className="btn btn-link store-activity-expandicon"
              data-toggle="collapse"
              href={`#collapseDescription${i}`}
              role="button"
              aria-expanded="false"
              aria-controls={`collapseDescription${i}`}
            >
              <i className="fa fa-collapsible" aria-hidden="true"></i>
            </a>
          </td>
          <td data-label={t("stores.activity.date")}>{transfer.date_created}</td>
          <td data-label={t("stores.activity.amount")}>
            {/* {getAmount(transfer)} */}
            {transfer.net_amount} USD
          </td>
          <td data-label={t("stores.activity.type")} className="activity-type-text">{transfer.transfer_type}</td>
          <td data-label={t("stores.activity.description")} className="expandable-description">
            {getDescription(transfer)}
            <div className="collapse" id={`collapseDescription${i}`}>
              {getDescriptionMeta(transfer)}
              {getExpiredMeta(transfer)}
            </div>
          </td>
          <td data-label={t("stores.activity.status")} className={transfer.active_class_by_status}>
            {getStatus(transfer)}
          </td>
          
          {transfer.is_received && (
            <td data-label={t("stores.activity.refund")}>
            <a
              className="btn-link btn-tiny"
              target="_blank"
              href={`/stores/${storeId}/send_usd?amount=${transfer.destination_amount}&email=${transfer.source_wallet_user_email}&ref=${transfer.id}`}
            >
              {t("stores.activity.refund")}
            </a>
            </td>
          )}

          <td data-label={t("stores.activity.view")}>
            <a
              className="btn-link btn-tiny"
              href={`/crypto_transfers/${transfer.id}?store=${storeId}`}
            >
              <i className="fa fa-eye"></i>
              {t("stores.activity.view")}
            </a>
          </td>
          <td className="actions trash" style={{cursor: "pointer"}}>
            {/* <span className={transfer.active_class_by_status}>
              {getResendConfirmationLink(transfer)}
            </span>
            <span>{getRemoveTransactionLink(transfer)}</span> */}
          </td>
        </tr>
      ))}
      {transfers.length === 0 && (
        <tr>
          <td colSpan={9} className="text-center">
            {t("stores.activity.none")}
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default Body;
